import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content absolute-fill" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "background absolute-fill" }, null, -1),
    _createElementVNode("div", { class: "bgShadow absolute-fill" }, null, -1),
    _createElementVNode("div", { class: "bottomShadow absolute-fill" }, null, -1)
  ])))
}